import { gql } from 'graphql-tag';

export default gql`
  query Maptiler {
    maptiler {
      key
    }
  }
`;
